import { Alert } from '@material-ui/lab';

import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';
import { useCustomTheme } from '@/hooks/useCustomTheme';

export const DistributionAlert = () => {
  const { customBorderRadius } = useCustomTheme();
  return (
    <Alert severity={'info'} style={{ borderRadius: customBorderRadius.paper }}>
      <Font variant={'body2'}>
        <Text tId={'APPLICATION_DISTRIBUTION_ALERT'} />
      </Font>
    </Alert>
  );
};
